import React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AvatarLabelGroup(props) {
  var body = props.body,
    header = props.header,
    image = props.image,
    initials = props.initials,
    onClick = props.onClick,
    size = props.size;
  var getHeaderFontSize = function getHeaderFontSize() {
    switch (size) {
      case 'sm':
        return 14;
      case 'md':
        return 14;
      case 'lg':
        return 16;
      case 'xl':
        return 18;
    }
  };
  var getHeaderLineHeight = function getHeaderLineHeight() {
    switch (size) {
      case 'sm':
        return '20px';
      case 'md':
        return '20px';
      case 'lg':
        return '24px';
      case 'xl':
        return '28px';
    }
  };
  var getBodyFontSize = function getBodyFontSize() {
    switch (size) {
      case 'sm':
        return 12;
      case 'md':
        return 14;
      case 'lg':
        return 16;
      case 'xl':
        return 16;
    }
  };
  var getBodyLineHeight = function getBodyLineHeight() {
    switch (size) {
      case 'sm':
        return '18px';
      case 'md':
        return '20px';
      case 'lg':
        return '24px';
      case 'xl':
        return '24px';
    }
  };
  var FlexedCenteredBox = styled(Box)(function () {
    return {
      alignItems: 'center',
      display: 'flex'
    };
  });
  var TypographyWrapper = styled(Box)(function () {
    return {
      marginLeft: 10
    };
  });
  var MainTypography = styled(Typography)(function () {
    return {
      fontFamily: 'Inter',
      fontStyle: 'normal'
    };
  });
  var HeaderTypography = styled(MainTypography)(function () {
    return {
      color: '#364152',
      fontSize: getHeaderFontSize(),
      fontWeight: 600,
      lineHeight: getHeaderLineHeight()
    };
  });
  var BodyTypography = styled(MainTypography)(function () {
    return {
      color: '#4B5565',
      fontSize: getBodyFontSize(),
      fontWeight: 400,
      lineHeight: getBodyLineHeight()
    };
  });
  var isFocusDisabled = onClick === undefined ? -1 : 0;
  return /*#__PURE__*/_jsxs(FlexedCenteredBox, {
    "data-element": "FlexedCenteredBox",
    "data-component": "AvatarLabelGroup",
    "data-source-file": "AvatarLabelGroup.tsx",
    children: [/*#__PURE__*/_jsx(MuiAvatar, {
      onClick: onClick,
      sizes: size,
      src: image,
      tabIndex: isFocusDisabled,
      "data-element": "MuiAvatar",
      "data-source-file": "AvatarLabelGroup.tsx",
      children: initials
    }), /*#__PURE__*/_jsxs(TypographyWrapper, {
      "data-element": "TypographyWrapper",
      "data-source-file": "AvatarLabelGroup.tsx",
      children: [/*#__PURE__*/_jsx(HeaderTypography, {
        "data-element": "HeaderTypography",
        "data-source-file": "AvatarLabelGroup.tsx",
        children: header
      }), /*#__PURE__*/_jsx(BodyTypography, {
        "data-element": "BodyTypography",
        "data-source-file": "AvatarLabelGroup.tsx",
        children: body
      })]
    })]
  });
}